import React from 'react';
import { useTheme } from 'styled-components';
import { HeadlineLevel } from '../Headline/Headline';
import {
  Headline400,
  Headline500,
  Headline600,
  Headline700,
  Headline800,
} from '../Headline';

/**
 * @constant
 * @type {{ [key: string]: string }}
 */
export const headlineMap = {
  Headline400,
  Headline500,
  Headline600,
  Headline700,
  Headline800,
};

/**
 * @param {DynamicHeadlineProps} props
 * @returns {React.ReactElement} The rendered component
 */
const getDynamicHeadline = ({ headline, theme }) => {
  const { tag, text } = headline;
  const elementName = theme.skinMap.heading[tag];
  const DynamicHeadline = headlineMap[elementName];
  return React.createElement(
    DynamicHeadline,
    { level: HeadlineLevel[tag] },
    text,
  );
};

/**
 * @param {HeadingProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Heading = ({ headline }) => {
  const theme = useTheme();
  return getDynamicHeadline({ headline, theme });
};

export default Heading;
